function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, Ref, ElementType, CSSProperties, Fragment } from 'react';
import cn from 'classnames';
import { Link, ILinkProps } from '../Link';
require("./Specs.css");
var styles = {
  "Root": "Specs-module-Root_2Xv",
  "Item": "Specs-module-Item_2lP",
  "Name": "Specs-module-Name_6kx",
  "Value": "Specs-module-Value_Wph"
};
export const Specs = ({
  className,
  controlRef,
  innerRef,
  items,
  linksProps = {
    variant: 'default'
  },
  style = {},
  tag = 'div',
  ...props
}) => {
  const Component = tag;
  if (!items || !Array.isArray(items) || items.length === 0) return null;
  return /*#__PURE__*/React.createElement(Component, _extends({
    style: style,
    className: cn(styles.Root, className),
    ref: innerRef || controlRef
  }, props, {
    role: "list"
  }), items.map(item => {
    const LinkWrapper = item.valueLink ? Link : Fragment;
    const linkProps = item.valueLink ? {
      href: item.valueLink,
      ...linksProps
    } : {};
    return /*#__PURE__*/React.createElement("div", {
      key: item.name,
      className: styles.Item,
      role: "listitem"
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.Name
    }, item.name), /*#__PURE__*/React.createElement("span", {
      className: styles.Value
    }, /*#__PURE__*/React.createElement(LinkWrapper, linkProps, item.value)));
  }));
};
if (process.env.NODE_ENV !== 'production') {
  Specs.displayName = 'Specs';
}